// extracted by mini-css-extract-plugin
export var body = "_k9-0";
export var sectionHeader = "_k9-4";
export var shortcutColumns = "_k9-2";
export var shortcutList = "_k9-1";
export var shortcutSection = "_k9-3";